import { Card, CardContent } from '@components/ui/Card';
import SEO from '@components/SEO';
import { Shield } from 'lucide-react';

export default function DatenschutzPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <SEO
        title="Datenschutz"
        pathname="/datenschutz"
        description="Datenschutzerklärung der Sternwarte Mannheim. Informationen zum Datenschutz und zur Verarbeitung personenbezogener Daten."
        noindex
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center">
            <Shield className="text-blue-400" size={24} />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">Datenschutzerklärung</h1>
        </div>

        <div className="space-y-6">
          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">1. Datenschutz auf einen Blick</h2>
              <p className="text-slate-300 leading-relaxed mb-4">
                Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Diese
                Datenschutzerklärung informiert Sie darüber, welche Daten wir erheben und wie
                wir sie verwenden.
              </p>
              <h3 className="text-lg font-semibold text-white mb-2">Verantwortlicher</h3>
              <p className="text-slate-300">
                Verein Stadtbild Mannheim e.V.
                <br />
                Aktionsbündnis Alte Sternwarte
                <br />
                A4,6, 68159 Mannheim
                <br />
                E-Mail: kontakt@sternwarte-mannheim.de
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">2. Datenerfassung auf dieser Website</h2>
              <h3 className="text-lg font-semibold text-white mb-2">Kontaktformular</h3>
              <p className="text-slate-300 leading-relaxed mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
                Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen
                Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
                Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
                Einwilligung weiter.
              </p>
              <h3 className="text-lg font-semibold text-white mb-2">Website-Analyse (Google Analytics 4)</h3>
              <p className="text-slate-300 leading-relaxed mb-4">
                Diese Website nutzt Google Analytics 4, einen Webanalysedienst der Google LLC
                (&quot;Google&quot;). Google Analytics verwendet Cookies, die eine Analyse der
                Benutzung der Website durch Sie ermöglichen. Die durch das Cookie erzeugten
                Informationen über Ihre Benutzung dieser Website werden in der Regel an einen
                Server von Google in den USA übertragen und dort gespeichert.
              </p>
              <p className="text-slate-300 leading-relaxed mb-4">
                <strong className="text-slate-200">IP-Anonymisierung:</strong> Auf dieser
                Website ist die IP-Anonymisierung aktiviert. Ihre IP-Adresse wird von Google
                innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen
                Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor
                gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von
                Google in den USA übertragen und dort gekürzt.
              </p>
              <p className="text-slate-300 leading-relaxed mb-4">
                <strong className="text-slate-200">Verarbeitungszweck:</strong> Google
                wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten,
                um Reports über die Website-Aktivitäten zusammenzustellen und um weitere mit
                der Website-Nutzung und der Internetnutzung verbundene Dienstleistungen
                gegenüber dem Website-Betreiber zu erbringen.
              </p>
              <p className="text-slate-300 leading-relaxed mb-4">
                <strong className="text-slate-200">Widerspruchsmöglichkeit:</strong> Sie
                können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
                Browser-Software verhindern. Sie können die Erfassung der durch das Cookie
                erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer
                IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google
                verhindern, indem Sie in unserem Cookie-Banner die Analyse-Cookies ablehnen
                oder das Browser-Plugin unter{' '}
                <a
                  href="https://tools.google.com/dlpage/gaoptout?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 underline"
                >
                  tools.google.com/dlpage/gaoptout
                </a>{' '}
                herunterladen und installieren.
              </p>
              <h3 className="text-lg font-semibold text-white mb-2">Verarbeitungszweck Kontaktformular</h3>
              <p className="text-slate-300 leading-relaxed">
                Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt
                ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
                Sie können diese Einwilligung jederzeit widerrufen.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">3. Ihre Rechte</h2>
              <p className="text-slate-300 leading-relaxed mb-4">
                Sie haben jederzeit das Recht auf:
              </p>
              <ul className="space-y-2 text-slate-300">
                <li>• Auskunft über Ihre bei uns gespeicherten Daten</li>
                <li>• Berichtigung unrichtiger Daten</li>
                <li>• Löschung Ihrer Daten</li>
                <li>• Einschränkung der Datenverarbeitung</li>
                <li>• Datenübertragbarkeit</li>
                <li>• Widerruf Ihrer Einwilligung</li>
              </ul>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">4. Speicherdauer</h2>
              <p className="text-slate-300 leading-relaxed">
                Wir speichern personenbezogene Daten nur so lange, wie dies zur Erreichung der
                jeweiligen Zwecke erforderlich ist oder wie es gesetzliche Aufbewahrungsfristen
                vorsehen.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">
                5. Beschwerderecht bei der zuständigen Aufsichtsbehörde
              </h2>
              <p className="text-slate-300 leading-relaxed">
                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht
                bei einer Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in
                datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des
                Bundeslandes Baden-Württemberg.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">
                6. SSL- bzw. TLS-Verschlüsselung
              </h2>
              <p className="text-slate-300 leading-relaxed">
                Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw.
                TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass
                die Adresszeile des Browsers von &quot;http://&quot; auf &quot;https://&quot;
                wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
